import axios from "axios";

export const USER_URL = "/users/getUser";
export const FILE_URL = "/files/getFile";
export const EDIT_USER_DATA_URL = "/users/editUserValue";
export const GENERATE_6101_CLOSE = "/files/generateForm6101CloseManually";
export const GENERATE_6101_NEW = "/files/generateForm6101NewManually";
export const GENERATE_101_CLOSE = "/files/generateForm6101CloseManually";
export const UPLOAD_FILES = "/files/uploadFile";
export const LIST_FILE_VERSIONS = "/files/listFileVersions";
export const DELETE_FILE = "/files/deleteFile";
export const GET_USERS_DD_LIST = "/users/getUsersDDList";
export const SET_INVITED_USER = "/users/setInvitedUser";
export const DISABLE_USER = "/users/disableUser";
export const ENABLE_USER = "/users/enableUser";
export const GET_USER_DATA_HISTORY = "/users/getUserAdditionalDataHistory";

export function getUser(queryParams) {
  return axios.get(USER_URL, { params: queryParams } );
}

export function getFile(uniqueId) {
  return axios.post(FILE_URL, {uniqueId})
}

export function editUserData({userID, paramName, paramValue}) {
  return axios.post(EDIT_USER_DATA_URL, {userID, paramName, paramValue})
}

export function generate6101({userID, selfEmployedEndDate}) {
  return axios.post(GENERATE_6101_CLOSE, {userID, selfEmployedEndDate})
}

export function generate6101New({userID}) {
  return axios.post(GENERATE_6101_NEW, {userID})
}

export function generate101({userID, selfEmployedEndDate}) {
  return axios.post(GENERATE_101_CLOSE, {userID, selfEmployedEndDate})
}

export function uploadFiles({formData}) {
  return axios.post(UPLOAD_FILES, formData)
}

export function listFileVersions({uniqueId}) {
  return axios.post(LIST_FILE_VERSIONS, {uniqueId})
}

export function deleteFile({userMongoID, fileName, fileMongoID}) {
  return axios.post(DELETE_FILE, {userMongoID, fileName, fileMongoID})
}

export function getUsersDDList(name) {
  return axios.post(GET_USERS_DD_LIST, {name});
}

export function setInvitedUser(invitedUserID, userID, date) {
  return axios.post(SET_INVITED_USER, {invitedUserID, userID, date});
}

export function disableUser(userID) {
  return axios.post(DISABLE_USER, {userID});
}

export function enableUser(userID) {
  return axios.post(ENABLE_USER, {userID});
}

export function getUserAdditionalDataHistory(queryParams) {
  return axios.get(GET_USER_DATA_HISTORY, { params: queryParams } );
}
